'use strict';

var $ = require('jquery');

function addClassOnLastOfLine(){
    var i;
    var products = $('.productCard__listingMode');

    for (i = 3; i <= products.length; i=i+4) {
        $(products[i]).addClass('lastOfLine');
    }
}

function btnClickCallFunction() {
    $('.show-more .btn').on('click', function(){
        setTimeout(function(){
            addClassOnLastOfLine();
            btnClickCallFunction();
        }, 3000);
    });
}

module.exports = {
    init: function() {
        $(document).ready(function() {
            $('.grid-filter li').on('click', function(e) {
                e.preventDefault();
                if($('.grid-filter li').hasClass('active')){
                    $('.grid-filter li').removeClass('active');
                }
                $(this).addClass('active');

                if($(this).hasClass('list-btn')) {
                    $('.container.search-results').removeClass('grid-list');
                } else {
                    $('.container.search-results').addClass('grid-list');
                }
            });

            addClassOnLastOfLine();
            btnClickCallFunction();
        });
    }
}
